import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tel',
  standalone: true,
})
export class TelPipe implements PipeTransform {
  transform(tel?: string): string {
    if (!tel?.toString()?.trim()) return '';

    const onlyNumbers = tel.replace(/[^0-9]/g, '');
    if (onlyNumbers.length !== tel.length) {
      return tel;
    }

    // 숫자만 있는 경우 포맷 적용
    return onlyNumbers.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  }
}
